import PresentismoAyudaIcon from "_+_Portal/assets/images/generico/PresentismoAyudaIcon";
import {
  BoxTurnoContainer,
  BuscadorBtn,
  BuscadorBtnContainer,
  BuscadorTurnosContainer,
  BuscadorTurnosContainer2,
  BuscadorTurnosContainer3,
  BuscadorTurnosContainer4,
  BuscarBtn,
  ErrorPermisoBox,
  OrdenBtn,
  OrdenContainer,
  OtrosTurnosContainer,
  PreguntaBox,
  PresentismoIconBox,
  TextoOrdenContainer,
  TurnoBtn,
} from "./localStyle";
import { useContext, useEffect, useState } from "react";
import { PortalContext } from "_+_Portal/context/Provider";
import camelize from "global/utils/camelize";
import BuscadorConsultaMedica from "../BuscadorConsultaMedica/BuscadorConsultaMedica";
import BuscadorEstudio from "../BuscadorEstudio/BuscadorEstudio";
import BuscadorLaboratorio from "../BuscadorLaboratorio/BuscadorLaboratorio";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { GlobalContext } from "global/context/Provider";
import WarningIcon from "_+_Portal/assets/images/generico/WarningIcon";
import { hideModal, showModal } from "_+_Portal/context/Actions/modal/modal";
import {
  finalizaEdicion,
  logoutPacientePerfil,
  wsGetDatosPaciente,
  wsPostEditarPaciente,
} from "_+_Portal/context/Actions/paciente/paciente";
import { showToaster } from "global/context/action/toaster/toaster";
import { resetEstudioMasBuscado } from "_+_Portal/context/Actions/estudioGrupo/estudioGrupo";
import { wsPostOrdenAsistencia } from "_+_Portal/context/Actions/ordenEstudio/ordenEstudio";
import { logoutEstudiosTurnos } from "_+_Portal/context/Actions/turnos/estudioTurnos";
import BuscadorConsultaMedica2 from "../BuscadorConsultaMedica/BuscadorConsultaMedica2";
import BuscadorEstudio2 from "../BuscadorEstudio/BuscadorEstudio2";
import BuscadorLaboratorio2 from "../BuscadorLaboratorio/BuscadorLaboratorio2";
import { useHistory } from "react-router";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";

const PasosTurno = ({
  pasos,
  setPasosCompletados,
  handlePasosCompletados,
  onChangeMultitabMobile,
  errorPermisos,
  div1Ref,
  div2Ref,
  div3Ref,
  div4Ref,
  setLoadingOrden,
  loading,
  setLoading,
}) => {
  //#region --------- context ---------------
  const { authState, toasterDispatch, configState } = useContext(GlobalContext);
  const {
    listaFamiliaresState,
    selectDropDownState,
    modalDispatch,
    pacienteState,
    pacienteDispatch,
    estudioGrupoState,
    estudioGrupoDispatch,
    ordenEstudioDispatch,
    estudioTurnosDispatch,
    ordenDigitalState,
    ordenDigitalDispatch,
  } = useContext(PortalContext);
  const history = useHistory();
  //#endregion  ----------- context ---------------

  //#region  ----------- constants ---------------
  const [tipoTurnoSelected, setTipoTurnoSelected] = useState(null);
  const [familiar, setFamiliar] = useState(null); // Guardará el nroDocumento del familiar seleccionado
  const [masSolicitado, setMasSolicitado] = useState({
    id: null,
    obj: null,
  });
  const [familiaresList, setFamiliaresList] = useState(false);
  const [disponibilidadFlg, setDisponibilidadFlg] = useState(false);
  const [observacionOrden, setObservacionOrden] = useState("");
  const [frenteOrdenFlg, setFrenteOrdenFlg] = useState(false);
  const [itemBusqueda, setItemBusqueda] = useState(null);
  const [arrayMasBucados, setArrayMasBucados] = useState([]);
  const [flgCargaTurnos, setFlgCargaTurnos] = useState(false);
  const [flgCargaFamiliares, setFlgCargaFamiliares] = useState(false);
  const [flgBtnEnvio, setFlgBtnEnvio] = useState(false);
  const [flgCircuitoOrden, setFlgCircuitoOrden] = useState(false);

  let config = localStorage.getItem("config");
  let opcEnviarOrdenSinTurno = JSON.parse(config).opcEnviarOrdenSinTurno;
  let opcLaboratorio = JSON.parse(config).opcLaboratorio;
  let opcEstudios = JSON.parse(config).opcEstudios;
  let opcConsultaMedica = JSON.parse(config).opcConsultaMedica;
  let accion = sessionStorage.getItem("accionHash");
  //#endregion --------- constants ---------------

  const vieneDeOrden = ordenDigitalState.ordenDigital.altaTurno !== null;

  //#region  ----------- funciones ---------------
  const volverAOrdenes = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    history.push("/ordenesDigitales");
  };

  const setearTipoTurno = (e) => {
    setTipoTurnoSelected(e);
    if (e === "E" || e === "L") {
      setMasSolicitado({
        id: null,
        obj: null,
      });
    }
  };

  const setearFamiliar = (nroDocumento) => {
    resetEstudioMasBuscado()(estudioGrupoDispatch);
    if (nroDocumento === undefined) {
      setFamiliar("");
    } else {
      setFamiliar(nroDocumento);
    }
    setFlgCargaTurnos(true);
  };

  const seleccionarMasSolicitado = (item, index) => {
    if (index === undefined) {
      setMasSolicitado("");
      setItemBusqueda(null);
    } else {
      setItemBusqueda(item);
      setMasSolicitado({
        id: index,
        obj: item,
      });
    }
  };

  const showFrenteOrden = (e) => {
    finalizaEdicion()(pacienteDispatch);
    // Si no se edito ningun dato paso directamente a la subida de orden
    // sin hacer el post de datos
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      if (
        e.email ===
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.email &&
        e.telefono_movil ===
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            .paciente.telefono_movil
      ) {
        dissmiss();
        setDisponibilidadFlg(true);
      } else {
        wsPostEditarPaciente(
          e,
          pacienteState.paciente.userSelect.pacienteSeleccionado.id
        )(pacienteDispatch);
      }
    } else {
      if (
        e.email === authState.auth.data.paciente.email &&
        e.telefono_movil === authState.auth.data.paciente.telefono_movil
      ) {
        dissmiss();
        setDisponibilidadFlg(true);
      } else {
        wsPostEditarPaciente(e)(pacienteDispatch);
      }
    }
  };

  const showModalEnviarOrden = () => {
    if (
      selectDropDownState.selectDropDown.selectGlobal.pacienteElegido === false
    ) {
      wsGetDatosPaciente()(pacienteDispatch);
    } else {
      wsGetDatosPaciente(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
      )(pacienteDispatch);
    }
    setFlgBtnEnvio(true);
  };

  const dissmiss = () => {
    hideModal()(modalDispatch);
    logoutEstudiosTurnos()(estudioTurnosDispatch);
  };
  const dissmissDiasDisponibles = () => {
    hideModal()(modalDispatch);
    logoutEstudiosTurnos()(estudioTurnosDispatch);
  };

  const dissmissOrden = () => {
    logoutPacientePerfil()(pacienteDispatch);
    hideModal()(modalDispatch);
  };

  const cerrarModal = (resp) => {
    if (!resp) {
      showToaster(
        {
          texto: "Error al subir la orden.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      dissmiss();
      showModal(
        "Genericos/AsistenciaModal/AsistenciaModal",
        {
          actualizarPagina: actualizarPagina,
          dissmiss: dissmiss,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }
    setLoadingOrden(false);
  };

  const actualizarPagina = () => {
    window.location.reload();
  };

  const setearDiasDisponibles = (dias, horarios) => {
    dissmiss();
    let diasDisp = dias.filter((item) => item.checked === true);
    let descripcionesDias = diasDisp.map((item) => item.descripcion);
    let diasConcatenados = descripcionesDias.join(", ");

    let horariosDisp = horarios.filter((item) => item.checked === true);
    let descripcionesHorarios = horariosDisp.map((item) => item.descripcion);
    let horariosConcatenados = descripcionesHorarios.join(", ");

    let arrayDisponible = {
      Dias: diasConcatenados,
      Horarios: horariosConcatenados,
    };
    setObservacionOrden(arrayDisponible);
    setFrenteOrdenFlg(true);
  };

  const finalizarProceso = (arrayImg) => {
    setLoadingOrden(true);
    let arrayOrdenes = [];
    for (let i = 0; i < arrayImg.length; i++) {
      const element = arrayImg[i];
      if (element.idRemoto === undefined) {
        element.idRemoto =
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido ===
          false
            ? authState.auth.data.paciente.codigo
            : selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id;
      }
      element.autocheck = false;
      element.observacion = JSON.stringify(observacionOrden);
      arrayOrdenes.push(element);
    }
    wsPostOrdenAsistencia(arrayOrdenes, cerrarModal)(ordenEstudioDispatch);
  };

  const enviarOrdenComponent = () => {
    return (
      <OrdenContainer>
        <TextoOrdenContainer>
          <p className="c-white rb18m">
            ¿No encontras lo que buscas o no entendes la letra de tu médico?
          </p>
          <p className="c-white rb14l subTxt">
            ¡Estamos para ayudarte! Solo necesitas subir la orden médica,
            completar tu disponibilidad horaria para que podamos brindarte el
            turno y aguardar el correo con la información del mismo.
          </p>
        </TextoOrdenContainer>
        <OrdenBtn className="c-white rb16m" onClick={showModalEnviarOrden}>
          Enviar orden médica
        </OrdenBtn>
      </OrdenContainer>
    );
  };

  //#endregion --------- funciones ---------------

  //#region  ----------- useEffect ---------------
  useEffect(() => {
    if (accion) {
      if (
        estudioGrupoState.estudioGrupo.data &&
        listaFamiliaresState.listaFamiliares.data
      ) {
        if (accion === "P") {
          handlePasosCompletados(1, "Estudio");
          setearTipoTurno("E");
        } else if (accion === "C") {
          handlePasosCompletados(1, "Consulta");
          setearTipoTurno("C");
        } else if (accion === "L") {
          handlePasosCompletados(1, "Labo");
          setearTipoTurno("L");
        }
        setFlgCargaFamiliares(true);
      }
    }
  }, [
    listaFamiliaresState.listaFamiliares.data,
    estudioGrupoState.estudioGrupo.data,
  ]);

  useEffect(() => {
    // tengo que resetear por si vengo del perfil de usuario
    logoutPacientePerfil()(pacienteDispatch);
  }, []);

  useEffect(() => {
    if (flgCargaFamiliares && familiaresList) {
      const familiarDNI = sessionStorage.getItem("familiarHash");

      if (familiarDNI) {
        const familiarIndex = familiaresList.findIndex(
          (fam) => fam.nroDocumento === parseInt(familiarDNI)
        );

        if (
          familiarIndex !== -1 &&
          familiaresList[familiarIndex].manejoTurnos
        ) {
          setearFamiliar(familiaresList[familiarIndex].nroDocumento);
          handlePasosCompletados(
            2,
            camelize(familiaresList[familiarIndex].nombre)
          );
          onChangeMultitabMobile(familiaresList[familiarIndex]);
        } else if (
          familiarIndex !== -1 &&
          !familiaresList[familiarIndex].manejoTurnos
        ) {
          setearFamiliar("");
          handlePasosCompletados(2, "Para Mi");
          onChangeMultitabMobile(familiaresList[0]);
        } else {
          setearFamiliar("");
          handlePasosCompletados(2, "Para Mi");
          onChangeMultitabMobile(familiaresList[0]);
        }
      } else {
        setearFamiliar("");
        handlePasosCompletados(2, "Para Mi");
        onChangeMultitabMobile(familiaresList[0]);
      }
    }
    //eslint-disable-next-line
  }, [flgCargaFamiliares, familiaresList]);

  // useEffect separado para completar paso 3 después de que paso 2 esté completo
  useEffect(() => {
    const accionHash = sessionStorage.getItem("accionHash");
    const familiarHash = sessionStorage.getItem("familiarHash");

    // Solo ejecutar si hay hash y si estamos en paso 2 (pasos.length === 2)
    if (accionHash && familiarHash && pasos.length === 2) {
      setTimeout(() => {
        // Para Consulta Médica: simular clic en "Buscar otras consultas"
        // Para Estudios/Labo: ir directo al buscador
        if (tipoTurnoSelected === "C") {
          // Consulta: completar paso 3 con "Otras" (muestra más solicitados primero)
          seleccionarMasSolicitado("");
          handlePasosCompletados(3, "Otras");
        } else {
          // Estudios/Labo: completar paso 3 con "Buscador" (directo)
          handlePasosCompletados(3, "Buscador");
        }

        // Limpiar sessionStorage después de usar
        sessionStorage.removeItem("accionHash");
        sessionStorage.removeItem("familiarHash");
      }, 300);
    }
    //eslint-disable-next-line
  }, [pasos]);

  useEffect(() => {
    if (listaFamiliaresState.listaFamiliares.data) {
      setFamiliaresList(
        dropdownFamiliares(
          listaFamiliaresState,
          authState,
          "ManejoTurnos",
          false
        )
      );
    }
    // eslint-disable-next-line
  }, [listaFamiliaresState.listaFamiliares.data]);

  useEffect(() => {
    if (errorPermisos) {
      setMasSolicitado({
        id: null,
        obj: null,
      });
    }
  }, [errorPermisos]);

  useEffect(() => {
    // Lo muevo al siguiente paso aunque de error el post
    // ya que existe la posibilidad de que el paciente no cambie ningun dato
    if (
      (pacienteState.paciente.data !== null &&
        pacienteState.paciente.data !== undefined) ||
      (pacienteState.paciente.error !== null &&
        pacienteState.paciente.error !== false)
    ) {
      if (
        pacienteState.paciente.data !== null &&
        pacienteState.paciente.data !== undefined
      ) {
        showToaster(
          {
            texto: "Datos actualizados correctamente.",
            tipo: "success",
          },
          "centroArriba"
        )(toasterDispatch);
      }
      dissmissOrden();
      setDisponibilidadFlg(true);
    }
  }, [pacienteState.paciente.data, pacienteState.paciente.error]);

  useEffect(() => {
    if (disponibilidadFlg) {
      showModal(
        "Turnos/DiasDisponibles/DiasDisponibles",
        {
          titulo: "Disponibilidad para toma de turno",
          onHandleDiasDisponibles: setearDiasDisponibles,
          dissmiss: dissmissDiasDisponibles,
        },
        [],
        "centro",
        true
      )(modalDispatch);
      setDisponibilidadFlg(false);
    }
  }, [disponibilidadFlg]);

  useEffect(() => {
    if (frenteOrdenFlg) {
      showModal(
        "Genericos/FrenteOrden/FrenteOrden",
        {
          finalizarProceso: finalizarProceso,
          dissmiss: dissmissDiasDisponibles,
        },
        [],
        "centro",
        true
      )(modalDispatch);
      setFrenteOrdenFlg(false);
    }
  }, [frenteOrdenFlg]);

  useEffect(() => {
    if (
      pacienteState.paciente.datosActualizados !== null &&
      pacienteState.paciente.datosActualizados !== undefined &&
      flgBtnEnvio
    ) {
      showModal(
        "Genericos/EnviarOrden/EnviarOrden",
        {
          subirOrden: showFrenteOrden,
          dissmiss: dissmissOrden,
        },
        [],
        "centro",
        true
      )(modalDispatch);
    }
  }, [pacienteState.paciente.datosActualizados, flgBtnEnvio]);

  useEffect(() => {
    if (
      estudioGrupoState.estudiosMasBuscado.data !== null &&
      estudioGrupoState.estudiosMasBuscado.data !== undefined &&
      flgCargaTurnos
    ) {
      if (pasos.length > 1 && pasos[0].desc === "Consulta") {
        let filtroConsulta = estudioGrupoState.estudiosMasBuscado.data.filter(
          (item) =>
            item.idCircuito !== "RMN" &&
            item.idCircuito !== "TOMO" &&
            item.sonPracticas === false
        );
        // Separo grupoMed de agendas
        const grupoMed = filtroConsulta.filter((item) => item.id > 0);
        const agenda = filtroConsulta.filter((item) => item.id < 0);
        // Concateno las agendas al final de gruposMed
        const turnosCompletos = grupoMed.concat(agenda);
        // Ordeno de mas buscados a menos
        turnosCompletos.sort((a, b) => {
          return b.cantBusquedas - a.cantBusquedas;
        });
        if (turnosCompletos.length === 0) {
          let borrarUltimo = pasos.filter((item) => item.id !== 3);
          setPasosCompletados(borrarUltimo);
          setMasSolicitado({
            id: null,
            obj: null,
          });
        }
        setArrayMasBucados(turnosCompletos.slice(0, 6));
      }
      setFlgCargaTurnos(false);
    }
  }, [estudioGrupoState.estudiosMasBuscado.data, flgCargaTurnos, pasos]);

  useEffect(() => {
    if (ordenDigitalState.ordenDigital.altaTurno !== null && familiaresList) {
      setearTipoTurno("E");
      handlePasosCompletados(1, "Estudio");
      setFlgCircuitoOrden(true);
    }
  }, [ordenDigitalState.ordenDigital.altaTurno, familiaresList]);

  useEffect(() => {
    if (flgCircuitoOrden) {
      // Si vengo con un familiar lo busco y lo seteo
      let pacienteSelected =
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id;
      if (pacienteSelected) {
        let findFamiliar = familiaresList.findIndex(
          (item) => item.id === pacienteSelected
        );
        if (findFamiliar !== -1) {
          setearFamiliar(familiaresList[findFamiliar].nroDocumento);
          handlePasosCompletados(
            2,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.nombre
          );
          onChangeMultitabMobile(familiaresList[findFamiliar]);
        }
      } else {
        setearFamiliar();
        handlePasosCompletados(2, "Para Mi");
        onChangeMultitabMobile(familiaresList[0]);
      }
      setFlgCircuitoOrden(false);
    }
  }, [flgCircuitoOrden]);
  //#endregion  ----------- useEffect ---------------

  return (
    <>
      <BoxTurnoContainer
        $ultimoPaso={pasos.length === 3}
        $minResolucion={window.innerWidth <= 1790}
      >
        <BuscadorTurnosContainer
          ref={div1Ref}
          $show={pasos.length >= 0}

        >
          <PreguntaBox>
            <p className="c-white rb18m">¿Para que estás buscando un turno?</p>
            <PresentismoIconBox
            // onClick={modalInfoPresentismo}
            >
              <PresentismoAyudaIcon width={18} height={18} />
            </PresentismoIconBox>
          </PreguntaBox>
          <p className="c-white rb16l">
            Seleccioná la opción según lo que estas buscando
          </p>
          <BuscadorBtnContainer>
            {opcConsultaMedica && (
              <BuscadorBtn
                className="ptur-buscadorTurnos-btnOpc c-white rb18l"
                onClick={() => {
                  setearTipoTurno("C");
                  handlePasosCompletados(1, "Consulta");
                }}
                $activo={
                  tipoTurnoSelected === null || tipoTurnoSelected === "C"
                }
              >
                Consulta médica
              </BuscadorBtn>
            )}
            {opcEstudios && (
              <BuscadorBtn
                className="ptur-buscadorTurnos-btnOpc c-white rb18l"
                onClick={() => {
                  setearTipoTurno("E");
                  handlePasosCompletados(1, "Estudio");
                }}
                $activo={
                  tipoTurnoSelected === null || tipoTurnoSelected === "E"
                }
              >
                Estudios
              </BuscadorBtn>
            )}
            {opcLaboratorio && (
              <BuscadorBtn
                className="ptur-buscadorTurnos-btnOpc c-white rb18l"
                onClick={() => {
                  setearTipoTurno("L");
                  handlePasosCompletados(1, "Labo");
                }}
                $activo={
                  tipoTurnoSelected === null || tipoTurnoSelected === "L"
                }
              >
                Laboratorio
              </BuscadorBtn>
            )}
          </BuscadorBtnContainer>
        </BuscadorTurnosContainer>

        <BuscadorTurnosContainer2
          ref={div2Ref}
          $show={pasos.length > 0}

          // className={pasos.length > 0 ? "visible" : "hidden"}
        >
          <PreguntaBox>
            <p className="c-white rb18m">¿Para quien es el turno?</p>
            <PresentismoIconBox
            // onClick={modalInfoPresentismo}
            >
              <PresentismoAyudaIcon width={18} height={18} />
            </PresentismoIconBox>
          </PreguntaBox>
          <BuscadorBtnContainer>
            <BuscadorBtn
              className="ptur-buscadorTurnos-btnOpc c-white rb18l"
              onClick={
                pasos.length > 0
                  ? () => {
                      setearFamiliar();
                      handlePasosCompletados(2, "Para Mi");
                      // Le envio el primer elemento que seria el paciente logueado
                      onChangeMultitabMobile(familiaresList[0]);
                    }
                  : () => {}
              }
              $activo={familiar === null || familiar === ""}
            >
              Para mi
            </BuscadorBtn>
            {familiaresList &&
              familiaresList.map((item, index) => {
                if (item.id !== authState?.auth?.data?.paciente?.codigo) {
                  const isActive = familiar === item.nroDocumento;
                  const noTienePermiso = item.familiar && !item.manejoTurnos;
                  return (
                    <BuscadorBtn
                      key={index}
                      className="ptur-buscadorTurnos-btnOpc c-white rb18l"
                      onClick={
                        pasos.length > 0
                          ? () => {
                              setearFamiliar(item.nroDocumento);
                              handlePasosCompletados(2, camelize(item.nombre));
                              onChangeMultitabMobile(item);
                            }
                          : () => {}
                      }
                      $activo={isActive}
                      $sinPermiso={noTienePermiso}
                    >
                      {camelize(item.nombre)}
                      {noTienePermiso && <span style={{fontSize: "11px", marginLeft: "4px"}}>(sin permisos)</span>}
                    </BuscadorBtn>
                  );
                }
              })}
          </BuscadorBtnContainer>
        </BuscadorTurnosContainer2>

        {errorPermisos && (
          <ErrorPermisoBox>
            <span className="ptur-misInformes-alerta">
              <WarningIcon color="var(--color-danger)" width={26} height={26} />
            </span>
            <p className="rb18m ptur-misInformes-alerta-texto">
              No posees permisos para gestionar turnos de este familiar.
            </p>
          </ErrorPermisoBox>
        )}

        {vieneDeOrden && (
          <div style={{ marginLeft: 24, marginTop: -16 }}>
            <BuscadorBtn
              className="ptur-buscadorTurnos-btnOpc c-white rb16m"
              onClick={volverAOrdenes}
              $activo={true}
              style={{ width: "auto", padding: "4px 16px", background: "transparent", border: "2px solid white" }}
            >
              Volver a Mis Ordenes
            </BuscadorBtn>
          </div>
        )}

        <BuscadorTurnosContainer3
          ref={div3Ref}
          $show={pasos.length > 1}

        >
          {estudioGrupoState.estudiosMasBuscado.data &&
            (pasos.length > 1 && pasos[0].desc === "Labo" ? (
              <>
                <p className="c-white rb18m">
                  Buscá el turno que necesitas, es fácil
                </p>
                <p className="c-white rb16l">¡Escribí lo que entiendas!</p>
                <BuscadorLaboratorio
                  onChangeMultitabMobile={
                    pasos.length > 2 ? onChangeMultitabMobile : () => {}
                  }
                  buscadorTurnos={true}
                />
              </>
            ) : pasos.length > 1 && pasos[0].desc === "Estudio" ? (
              <>
                <p className="c-white rb18m">
                  Buscá el turno que necesitas, es fácil
                </p>
                <p className="c-white rb16l">¡Escribí lo que entiendas!</p>
                <BuscadorEstudio
                  onChangeMultitabMobile={
                    pasos.length > 2 ? onChangeMultitabMobile : () => {}
                  }
                  buscadorTurnos={true}
                  itemBusqueda={itemBusqueda}
                  setLoading={setLoading}
                />
                {opcEnviarOrdenSinTurno && enviarOrdenComponent()}
              </>
            ) : estudioGrupoState.estudiosMasBuscado.data &&
              arrayMasBucados.length > 0 &&
              arrayMasBucados !== undefined &&
              arrayMasBucados !== null ? (
              <>
                <p className="c-white rb18m">
                  Estas son tus consultas médicas más solicitadas
                </p>
                <p className="c-white rb16l">
                  Si buscas un turno distinto a los que aparecen en la pantalla,
                  visualizá otras opciones de consultas médicas haciendo clic en
                  "Buscar otras consultas"
                </p>
                <BuscadorBtnContainer $centrado={true}>
                  {arrayMasBucados &&
                    arrayMasBucados.map((item, index) => (
                      <TurnoBtn
                        key={index}
                        className="ptur-buscadorTurnos-btnOpc c-white rb18l"
                        onClick={
                          pasos.length > 1
                            ? () => {
                                seleccionarMasSolicitado(item, index);
                                handlePasosCompletados(3, item.id);
                              }
                            : () => {}
                        }
                        $activo={
                          masSolicitado.id === null ||
                          masSolicitado.id === index
                        }
                      >
                        {camelize(item.descripcion)}
                      </TurnoBtn>
                    ))}
                </BuscadorBtnContainer>
                <OtrosTurnosContainer>
                  <BuscarBtn
                    className="ptur-buscadorTurnos-btnOpc c-white rb18l"
                    onClick={
                      pasos.length > 1
                        ? () => {
                            seleccionarMasSolicitado("");
                            handlePasosCompletados(3, "Otras");
                          }
                        : () => {}
                    }
                    $activo={masSolicitado === ""}
                  >
                    Buscar otras consultas
                  </BuscarBtn>
                </OtrosTurnosContainer>
              </>
            ) : (
              pasos.length > 0 && (
                <>
                  <p className="c-white rb18m">
                    Buscá el turno que necesitas, es fácil
                  </p>
                  <p className="c-white rb16l">¡Escribí lo que entiendas!</p>
                  <BuscadorConsultaMedica
                    onChangeMultitabMobile={
                      pasos.length > 2 ? onChangeMultitabMobile : () => {}
                    }
                    buscadorTurnos={true}
                    itemBusqueda={itemBusqueda}
                  />
                </>
              )
            ))}
        </BuscadorTurnosContainer3>

        <BuscadorTurnosContainer4
          ref={div4Ref}
          $show={pasos.length === 3}

        >
          <p className="c-white rb18m">
            Buscá el turno que necesitas, es fácil
          </p>
          <p className="c-white rb16l">¡Escribí lo que entiendas!</p>
          {pasos.length === 3 && pasos[0].desc === "Consulta" && (
            <BuscadorConsultaMedica
              onChangeMultitabMobile={
                pasos.length > 2 ? onChangeMultitabMobile : () => {}
              }
              buscadorTurnos={true}
              itemBusqueda={itemBusqueda}
            />
          )}
        </BuscadorTurnosContainer4>
      </BoxTurnoContainer>
    </>
  );
};

export default PasosTurno;
